<template>
  <v-card class="import-dataset">
    <v-card-title class="justify-center"> Import Dataset </v-card-title>
    <v-card-text class="d-flex flex-column">
      <v-form ref="form">
        <v-row no-gutters>
          <v-col cols="3" class="input-label">Dataset </v-col>
          <v-col cols="9">
            <v-text-field dense :value="dataset.title" readonly></v-text-field>
          </v-col>
        </v-row>
        <v-row no-gutters>
          {{ type }}
          <v-col cols="3" class="input-label">Period </v-col>
          <v-col cols="9">
            <RbuPeriodInput
              outlined
              dense
              v-model="period"
              :rules="requiredRules"
            ></RbuPeriodInput>
          </v-col>
        </v-row>
        <v-row no-gutters>
          <v-col cols="3" class="input-label">
            {{ "Excel File" }}
            <div>
              <a
                href="dataset_import_template.xlsx"
                target="_blank"
                style="color: var(--v-primary-base)"
                >Download Template</a
              >
            </div>
          </v-col>
          <v-col cols="9">
            <FileInput
              v-model="file"
              :accept="'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'"
              :rules="requiredRules"
            ></FileInput>
          </v-col>
        </v-row>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="secondary" @click="$emit('submit', false)" depressed large>
        {{ $t("cancel") }}
      </v-btn>
      <v-spacer></v-spacer>
      <v-btn
        color="primary"
        @click="$refs.form.validate() && confirm()"
        depressed
        large
      >
        {{ $t("save") }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
import { ref } from "@vue/composition-api";
import { ACTION_TYPES } from "@/store/types";
import FileInput from "@/components/FileInput";
import RbuPeriodInput from "@/components/rbu/RbuPeriodInput.vue";

export default {
  name: "ImportDatasetExcelDialog",
  components: { RbuPeriodInput, FileInput },
  props: {
    dataset: Object,
  },
  setup(props, { root, emit }) {
    const requiredRules = ref([
      (value) => !!value || root.$t("rules.required"),
    ]);

    const period = ref(null);
    const file = ref(null);

    const confirm = async function () {
      let formData = new FormData();
      formData.append("dataset_id", props.dataset.id);
      formData.append("period", period.value);
      formData.append("file", file.value, file.value.name);

      let response = await root.$store.dispatch(ACTION_TYPES.CALL_API, {
        url: "admin/dataset/import/",
        params: formData,
      });

      if (response.body.success) {
        emit("submit", true);
      }
    };

    return {
      requiredRules,

      period,
      file,

      confirm,
    };
  },
};
</script>

<style lang="less">
.import-dataset {
  .input-label {
    text-align: right;
    padding: 4px 16px 0 0 !important;
  }

  .step-1-wrapper {
    flex: 1 0 0;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
  }
}
</style>
